import { CommonModule } from "@angular/common";
import { Component, HostListener } from "@angular/core";
import { RouterOutlet, Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { filter } from "rxjs";
import { environment } from "../../../../environments/environment";
import { RoutesMapper } from "../../../routes-mapper";
import { navType, AppConfigService } from "../../../services/config/app-config.service";
import { ThemeToggleService } from "../../../services/theme-Toggle/theme-toggle.service";
import { SsoAuthService } from "../../../sso/Services/sso-auth.service";
import { ThemeToggleComponent } from "../../theme-toggle/theme-toggle.component";
import { UserProfileHeaderComponent } from "../../user-profile-header/user-profile-header.component";
@Component({
  selector: 'app-user-phil-side-nav',
  imports: [RouterOutlet, CommonModule, ThemeToggleComponent, UserProfileHeaderComponent],
  templateUrl: './user-phil-side-nav.component.html',
  styleUrl: './user-phil-side-nav.component.scss',
})
export class UserPhilSideNavComponent {
  selectedNavIndex: Number = 0;
  adminClicked: boolean = false
  public themeStyles: any;
  userDetails: any = {};
  showThemes: boolean = false;
  public navBar: navType[] = [];
  showApps: boolean = false;
  orgUrl = environment.orgUrl;
  // accoUrl = environment.accoUrl;
  constructor(
    private themeToggleService: ThemeToggleService,
    public _router: Router,
    private ssoAuthService: SsoAuthService
  ) {
    this.themeToggleService.applyTheme('dark-gold');
  }
  ngOnInit() {
    let HtmlRootClass = document.getElementsByClassName('dark-gold');
    this.themeStyles = getComputedStyle(HtmlRootClass.item(0)!);
    this.userDetails = JSON.parse(localStorage.getItem('UserDetails')!);
    // this.navBar = this.appConfig.getSideNavigation(this.themeStyles);
    if (this._router.url.includes(RoutesMapper.ADMIN) && this.userDetails?.showAllTransactions) {
      this.navBar = []
      this.adminClicked = true
      this.navBar.push(

        {
          label: 'All Family Codes',
          webRoute: `${RoutesMapper.ALL_FC}`,
        },
        {
          label: 'Submit Arghya',
          webRoute: `${RoutesMapper.SUBMIT_ARGHYA}`,
        },
        {
          label: 'Pending FC',
          webRoute: `${RoutesMapper.PENDING_FAMILY_CODES}`,
        },
        {
          label: 'All Transaction',
          webRoute: `${RoutesMapper.ALL_TRANSACTION}`,
        },
        {
          label: 'Generate FC',
          webRoute: `${RoutesMapper.GENERATE_FC}`,
        },
      )
    } else {
      this.adminClicked = false
      this.navBar = [
        {
          label: 'Oblation devotion',
          webRoute: 'new-deposit',
        },
        {
          label: 'All Offerings',
          webRoute: 'transaction',
        },
        {
          label: 'My family',
          webRoute: 'family-members',
        },
        {
          label: 'Offering codes',
          webRoute: 'deposit-codes',
        },
        {
          label: 'Terms & Conditions',
          webRoute: 'terms-and-conditions',
        },
        {
          label: 'Privacy Policy',
          webRoute: 'privacy-policy',
        },
        {
          label: 'Refund & Cancellation Policy',
          webRoute: 'refund-policy',
        },
        {
          label: 'Contact Us',
          webRoute: 'contact-us'
        },
      ];
      // if (this.userDetails?.showAllTransactions) {
      //   this.navBar.push({
      //     label: 'Admin',
      //     webRoute: 'admin',
      //   },
      //   )
      // }
    }
    let userDetails: any = localStorage.getItem('UserDetails')
    userDetails = JSON.parse(userDetails);
    if (userDetails?.showAllTransactions) {
    }
    console.log('rerendering ..............', this.navBar);
    // select the side nav based on url
    let routerArray = this._router.url.split('?')[0].split('/');
    routerArray = routerArray.splice(1, routerArray.length);
    let i = 0;
    for (let navTab of this.navBar) {
      if (navTab.webRoute === routerArray[0]) {
        this.selectedNavIndex = i;
        break;
      }
      i++;
    }
    this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const urlParts = event.urlAfterRedirects.split('/');
        const selected = urlParts[1] || '';
        if (selected) {
          let selectedIndex = -1;
          let selectedItem: any;
          for (let i = 0; i < this.navBar.length; i++) {
            if (this.navBar[i].webRoute === selected) {
              selectedIndex = i;
              selectedItem = this.navBar[i];
              break;
            }
          }
          if (selectedIndex != -1) {
            this.selectNavItem(selectedItem, selectedIndex);
          }
        }
      });
  }
  @HostListener('document:click')
  closeMenu() {
    this.showThemes = false;
  }
  logOut() {
    this._router.navigate(['/login'])
  }
  onAdminClick() {
    this.adminClicked = !this.adminClicked
    const url = this.adminClicked ? 'admin' : 'user'
    window.open(`/${RoutesMapper.ADMIN}/${RoutesMapper.ALL_FC}`, '_blank');
  }
  setTheme(theme: string, event: Event) {
    this.themeToggleService.applyTheme(theme);
  }
  onThemeClick(event: Event) {
    this.showThemes = !this.showThemes;
    if (this.showThemes) this.showApps = false;
    event.stopPropagation();
  }
  logout(event: Event) {
    this.ssoAuthService.logOut();
    event.stopPropagation();
  }
  selectNavItem(item: any, index: number) {
    if (index !== this.selectedNavIndex) {
      this.selectedNavIndex = index;
      if (item.webRoute) {
        this._router.navigate(this._router.url.includes('/admin') ? ['admin/' + item.webRoute] : [item.webRoute]);
      }
    }
  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.acco-header')) {
      this.showThemes = false;
      this.showApps = false;
    }
  }
  // toggleShowApps(e: any) {
  //   e.stopPropagation()
  //   this.showThemes = false;
  //   this.showApps = !this.showApps;
  // }
  // clickApps(url: string) {
  //   window.location.href = url;
  // }
  // onViewProfile(): void {
  //   window.open(environment.SSO_URL + '/dashboard', '_blank');
  // }
  // logOut() {
  //   localStorage.clear();
  //   this._router.navigate(['/login']);
  // }
  // onSelectTheme(value: number) {
  //   value === 1
  //     ? this.themeToggleService.applyTheme('dark-gold')
  //     : this.themeToggleService.applyTheme('light-gold');
  // }
}
